import { API_BASE_URL } from 'app/constants';

export const CUTTING_PRINTING_INFO_URL = `${API_BASE_URL}/cutting-printing-info/`;
